import { useGame } from '../../context/GameContext'
import { getGuessStatuses } from '../../lib/statuses'
import { MiniCell } from './MiniCell'

type Props = {
    guess: string
}

export const MiniCompletedRow = ({ guess }: Props) => {
    const { wordIndex } = useGame()
    const statuses = getGuessStatuses(guess, wordIndex)

    return (
        <div className="flex justify-center mb-1">
            {guess.split('').map((letter, i) => (
                <MiniCell key={i} status={statuses[i]} />
            ))}
        </div>
    )
}
